import { motion } from "framer-motion";
import { useLang } from "../LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";

export const Timeline = () => {
  const { t } = useLang();
  return (
    <section id="process" data-testid="timeline" className="relative py-24 md:py-32 bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-16">
          <Reveal><Eyebrow testId="timeline-eyebrow">{t.timeline.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl md:text-6xl text-white tracking-tight leading-[1.05]">
              {t.timeline.title1} <span className="text-gold-gradient italic">{t.timeline.title2}</span>
            </h2>
          </Reveal>
        </div>

        <div className="relative pl-8 md:pl-0">
          <div className="absolute left-[7px] md:left-1/2 top-0 bottom-0 w-px bg-white/10 md:-translate-x-1/2" />
          <div className="space-y-12 md:space-y-0">
            {t.timeline.steps.map((s, i) => (
              <motion.div
                key={i}
                data-testid={`timeline-step-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: 0.05 }}
                className={`relative md:grid md:grid-cols-2 md:gap-16 md:py-10 ${i % 2 === 1 ? "md:text-right" : ""}`}
              >
                <div className="absolute -left-8 md:left-1/2 top-1 md:-translate-x-1/2">
                  <span className="block w-4 h-4 rounded-full bg-[#d4af37] gold-glow" />
                </div>
                <div className={`${i % 2 === 1 ? "md:col-start-2" : "md:col-start-1"}`}>
                  <div className="text-[11px] tracking-[0.3em] uppercase text-[#d4af37] mb-2">{t.timeline.stepLabel} {s.step}</div>
                  <h3 className="font-display text-2xl md:text-3xl text-white">{s.title}</h3>
                  <p className="mt-3 text-[#a3a3a3] leading-relaxed max-w-md md:inline-block">{s.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
